import { App } from '@capacitor/app';

import { datadogRum } from '@datadog/browser-rum';

import { getCoreConfig } from '../config/config';

export const versions = {
  getAppVersion: (): string => {
    return getCoreConfig().appVersion;
  },
  getBinaryVersion: async (): Promise<string | undefined> => {
    if (getCoreConfig().isNative) {
      try {
        return (await App.getInfo()).version;
      } catch (e) {
        datadogRum.addError(e);
        return Promise.resolve(undefined);
      }
    }
    return Promise.resolve(undefined);
  },
};

export default versions;
